import { useLinked } from "@linked/react/lib";
import { makeStyles, styled } from "@material-ui/core";
import { Button, Flex, PopupDialog } from "lqx-react/lib";
import React from "react";
import { TargetFieldCard } from "../../../api/targetFieldCard";
import { DigiSelect } from "../../../components/select";
import { ErrorHighligter } from "../../../shared";
import { AssetColumn, AssetLabel } from "../../../components/number-input";

export const ComputedSelectionPopup = ({ onComputedSelectionApply, onClose, inBlockComputedFields, resultFields }
  : { onComputedSelectionApply: any, onClose: any, inBlockComputedFields: TargetFieldCard[], resultFields: TargetFieldCard[] }) => {
  const $field_1 = useLinked({ id: null, name: '' }).check(x => Boolean(x.id));
  const $field_2 = useLinked({ id: null, name: '' }).check(x => Boolean(x.id));
  const $operator = useLinked({ id: null, name: '' }).check(x => Boolean(x.id));
  const $resultField = useLinked({ id: null, name: '' }).check(x => Boolean(x.id));

  const operators = [
    { id: 1, name: '+' },
    { id: 2, name: '-' }
  ];

  const classes = makeErrorHighlighterStyles();

  const disableApplyButton = () => {
    return (Boolean($field_1.error) || Boolean($field_2.error) || Boolean($operator.error) || Boolean($resultField.error))
  }
  return (
    <>
      <MapSourceFieldsPopupDialog
        title='Computed fields selection'
        actions={
          <>
            <Button disabled={disableApplyButton()} onClick={() => onComputedSelectionApply($field_1.value, $field_2.value, $operator.value.name, $resultField.value)}>
              Apply
            </Button>
          </>
        }
        maxWidth='md'
        fullWidth={true}
        hideTitle={false}
        onClose={onClose}
      >

        <Flex row>
          <AssetColumn>
            <AssetLabel>Field 1</AssetLabel>
            <ErrorHighligter error={$field_1.error} classes={classes}>
              <InBlockFieldSelect id="id" label="name" $value={$field_1} options={inBlockComputedFields}></InBlockFieldSelect>
            </ErrorHighligter>
          </AssetColumn>

          <AssetColumnOperator>
            <AssetLabel>Operator</AssetLabel>
            <ErrorHighligter error={$operator.error} classes={classes}>
              <InBlockFieldSelect id="id" label="name" $value={$operator} options={operators}></InBlockFieldSelect>
            </ErrorHighligter>
          </AssetColumnOperator>

          <AssetColumn>
            <AssetLabel>Field 2</AssetLabel>
            <ErrorHighligter error={$field_2.error} classes={classes}>
              <InBlockFieldSelect id="id" label="name" $value={$field_2} options={inBlockComputedFields}></InBlockFieldSelect>
            </ErrorHighligter>
          </AssetColumn>
        </Flex>

        <Flex row>
          <AssetColumnResultField>
            <AssetLabel>Result Field</AssetLabel>
            <ErrorHighligter error={$resultField.error} classes={classes}>
              <InBlockFieldSelect id="id" label="name" $value={$resultField} options={resultFields}></InBlockFieldSelect>
            </ErrorHighligter>
          </AssetColumnResultField>
        </Flex>
      </MapSourceFieldsPopupDialog>
    </>
  );
};

const AssetColumnOperator = styled(AssetColumn)({
  maxWidth: '70px',
  minWidth: '70px'
});

const AssetColumnResultField = styled(AssetColumn)({
  maxWidth: '373px',
});

const InBlockFieldSelect = styled(DigiSelect)({
});

const MapSourceFieldsPopupDialog = styled(PopupDialog)({
  '& .MuiDialog-paperFullWidth': {
  }
});

const makeErrorHighlighterStyles = makeStyles({
  root: {
    border: '2px solid #ffdf71 !important',
    paddingLeft: '5px',
    borderRadius: '10px',
    paddingRight: '5px',
    height: '42px',
    '& [class*="-control"]': {
      border: 'none !important'
    }
  },
});
